// extracted by mini-css-extract-plugin
module.exports = {"varSpDown2":"0.5rem","toggle":"toggle--68457","content":"content--97df8","switchContainer":"switchContainer--175a3"};